import { Localization } from '../localization/localization';
import { PassStrengthEvaluator } from '../utils/pass-strength-evaluator';

export class PasswordStrengthWidget {
    private widgetRoot: JQuery<HTMLElement>;

    constructor(widgetRoot: JQuery<HTMLElement>) {
        this.widgetRoot = widgetRoot;
    }

    public setPasswordStrength(strength: number) {
        const strengthText = Localization._n(`password_strength.${strength}`);
        this.widgetRoot.find('.password-strength-widget__text').text(strengthText);
        const meter = this.widgetRoot.find('.password-strength-widget__meter');
        const maxStrength = 4;
        for (const key of (new Array(maxStrength + 1)).keys()) {
            meter.removeClass(PasswordStrengthWidget.getMeterStrengthClass(key));
        }
        meter.addClass(PasswordStrengthWidget.getMeterStrengthClass(strength));
    }

    private static getMeterStrengthClass(strength: number) {
        return `password-strength-widget__meter_${strength}`;
    }
}

export function setupPassStrengthWidgetListener() {
    let debounceTimeout: number;

    $(document).on('keyup', 'input[type="password"].js-pass-strength-meter', function onPassKeyUp() {
        window.clearTimeout(debounceTimeout);
        debounceTimeout = window.setTimeout(async() => {
            const nearestStrengthWidgetRoot = $(this).parents('form')
                .find('.password-strength-widget');

            if (nearestStrengthWidgetRoot.length) {
                await PassStrengthEvaluator.libIsLoaded();
                const strengthWidget = new PasswordStrengthWidget(nearestStrengthWidgetRoot);
                const password = String($(this).val());
                const strength = PassStrengthEvaluator.evaluate(password);
                strengthWidget.setPasswordStrength(strength);
            }
        }, 200);
    });
}

export function setupPassStrengthWidgetListener4Step() {
    let debounceTimeout: number;

    $(document).on('keyup', 'input[type="password"].js-pass-strength-meter', function onPassKeyUp() {
        window.clearTimeout(debounceTimeout);
        debounceTimeout = window.setTimeout(async() => {
            const nearestStrengthWidgetRoot = $(this).parents('.registration-4-step__step2')
                .find('.password-strength-widget');

            if (nearestStrengthWidgetRoot.length) {
                await PassStrengthEvaluator.libIsLoaded();
                const strengthWidget = new PasswordStrengthWidget(nearestStrengthWidgetRoot);
                const password = String($(this).val());
                const strength = PassStrengthEvaluator.evaluate(password);
                strengthWidget.setPasswordStrength(strength);
            }
        }, 200);
    });
}

export function setupPassStrengthWidgetListenerFbEmail() {
    let debounceTimeout: number;

    $(document).on('keyup', 'input[type="password"].js-pass-strength-meter', function onPassKeyUp() {
        window.clearTimeout(debounceTimeout);
        debounceTimeout = window.setTimeout(async() => {
            const nearestStrengthWidgetRoot = $(this).parents('.registration-fb-email__step-2')
                .find('.password-strength-widget');

            if (nearestStrengthWidgetRoot.length) {
                await PassStrengthEvaluator.libIsLoaded();
                const strengthWidget = new PasswordStrengthWidget(nearestStrengthWidgetRoot);
                const password = String($(this).val());
                const strength = PassStrengthEvaluator.evaluate(password);
                strengthWidget.setPasswordStrength(strength);
            }
        }, 200);
    });
}
